import {ScheduledTaskComponent} from "./components/scheduled_task_component/ScheduledTaskComponent";
import {PeriodPickerController} from "./components/period_picker/periodPicker";
import {ZONE_IDS} from "./const/timezonesConst";
import {SchedulingController} from "./route/schedulingController";
import SchedulingModuleConfiguration from "./SchedulingModuleConfiguration";
import './route/schedules.scss';
import {ScheduledTaskQueueComponent} from "./components/scheduled_task_queue/scheduled-task-queue.component";


function Strategy(value, title) {
    this.value = value;
    this.title = title;
}

function TriggerType(value, title) {
    this.title = title;
    this.value = value;
}

SchedulingModuleConfiguration
    .createNewModule()
    .component('scheduledTaskComponent', {
        controller: ['$scope', '$mdToast', 'SchedulesService', '$mdDialog', 'TRIGGER_TYPES', 'STRATEGIES_ENUM', ScheduledTaskComponent],
        template: require('./components/scheduled_task_component/scheduled_task_component.html'),
        bindings: {schedule: '<'}
    })
    .component('periodPicker', {
        template: require('./components/period_picker/period_picker.html'),
        controller: ['$scope', 'SchedulesService', 'STRATEGIES_ENUM', PeriodPickerController],
        bindings: {'trigger': '='}
    })
    .component('scheduledTaskQueue', ScheduledTaskQueueComponent.instance)
    .controller('schedulingController', ['$scope', 'scheduledTasks', 'tasksQueue', 'LoaderStatusValue', SchedulingController])
    .constant('STRATEGIES_ENUM', {
        RUN_UNTIL: new Strategy("RUN_UNTIL", "Run until"),
        RUN_FOR_PERIOD: new Strategy("RUN_FOR_PERIOD", "Run for period"),
        RUN_STARTING_FROM: new Strategy("RUN_STARTING_FROM", "Run starting from"),
        RUN_INDEFINITELY: new Strategy("RUN_INDEFINITELY", "Run indefinitely"),
    })
    .constant('TRIGGER_TYPES', {
        CRON_JOB: new TriggerType('CRON_JOB', 'Cron'),
        TIMEOUT: new TriggerType('TIMEOUT', 'Interval')
    })
    .constant('ZONE_IDS', ZONE_IDS);




